import { request } from "@/store";
import Filter from "@/store/filter";
var _ = require("lodash");
const pricing_and_margin = {
  state: {
    list: [],
    download_list: [],
    total_rows: null,
    sellers_filter: new Filter([], [], "id"),
    marketplaces_filter: new Filter([], [], "sales_channel"),
    products_filter: new Filter([], [], "id"),
    segments_filter: new Filter([], [], "segments"),
    keyword_list: [],
    filterManager: null,
    currentTab: 0,
    currentTabValue: "pricing_margin",
    tabs: [{
      text: "Pricing and Margin",
      value: "pricing_margin",
      activeBg: "#F4F4F4",
      activeColor: "#4D4D4D",
      url: "/pricing-and-margin",
      icon: "StrokedStarIcon"
    }
    // {
    //   text: "Repricer",
    //   value: "pricing_and_margin_repricer",
    //   activeBg: "#F4F4F4",
    //   activeColor: "#1755AB",
    //   url: "/pricing-and-margin-v2",
    //   icon: "SettingsIcon",
    //   disabled: true,
    // },
    ]
  },
  mutations: {
    pricingMarginSellersFilterSet(state, payload) {
      state.sellers_filter.restore(payload);
    },
    pricingMarginMarketplacesFilterSet(state, payload) {
      state.marketplaces_filter.restore(payload);
    },
    pricingAndMarginSetCurrentTabSet(state, payload) {
      const index = state.tabs.findIndex(tab => tab.value === payload);
      if (index === -1) return; // optional safeguard

      state.currentTab = index;
      state.currentTabValue = payload;
    },
    pricingAndMarginDataListSet(state, payload) {
      state.list = payload;
    },
    pricingAndMarginDataListSetToDownload(state, payload) {
      state.download_list = payload;
    },
    pricingMarginDataKeywordsListSet(state, payload) {
      state.keyword_list = payload;
    },
    pricingMarginDataTotalRowSet(state, payload) {
      state.total_rows = payload;
    },
    pricingMarginProductsKeyWordListSet(state, payload) {
      state.keyword_list = payload;
    },
    pricingMarginSetFilterManager(state, payload) {
      state.filterManager = payload;
    }
  },
  getters: {
    pricingAndMarginGetTab(state) {
      return () => state.currentTab;
    },
    pricingAndMarginGetTabValue(state) {
      return () => {
        if (!state.tabs || !state.tabs[state.currentTab]) return null;
        return state.tabs[state.currentTab].value;
      };
    },
    pricingAndMarginSellersListGet(state) {
      return () => {
        return state.sellers_filter.filterValues;
      };
    },
    pricingAndMarginMarketPlacesListGet(state) {
      return () => {
        return state.marketplaces_filter.filterValues;
      };
    },
    pricingAndMarginProductsGetSkus(state) {
      return () => {
        return Filter.merge({
          source1: 'sku_list',
          source2: 'sku'
        }, state.segments_filter.selected, state.products_filter.selected);
      };
    },
    pricingAndMarginProductsGetAsins(state) {
      return () => {
        return Filter.merge({
          source1: 'asin_list',
          source2: 'asin'
        }, state.segments_filter.selected, state.products_filter.selected);
      };
    },
    pricingAndMarginSegmentsGetAsins(state) {
      return () => {
        return Filter.flatten('asin_list', state.segments_filter.selected);
      };
    }
  },
  actions: {
    pricingAndMarginSetTab({
      commit
    }, tab) {
      commit('pricingAndMarginSetCurrentTabSet', tab);
    },
    async pricingAndMarginGetByFilters({
      commit
    }, payload) {
      let result = (await request("/inventory/pricing_and_margin/get_pricing_and_margin_data_from_gcp_by_filters", "POST", payload)) ?? {
        data: [],
        suggestions: []
      };
      if (result.data) {
        commit("pricingAndMarginDataListSet", result.data);
        commit("pricingMarginDataTotalRowSet", result.total_rows);
      }
      return result;
    },
    async pricingAndMarginGetByFiltersToDownload({
      commit
    }, payload) {
      let result = (await request("/inventory/pricing_and_margin/get_pricing_and_margin_data_from_gcp_by_filters", "POST", payload)) ?? {
        data: [],
        suggestions: []
      };
      if (result.data) {
        //console.log("[total data to download]");
        commit("pricingAndMarginDataListSetToDownload", result.data);
      }
      return result;
    },
    pricingMarginSetFilterManager({
      commit
    }, filterManager) {
      commit('pricingMarginSetFilterManager', filterManager);
    }
  }
};
export default pricing_and_margin;